/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Loading/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import CloseIconAction from './CloseIconAction/index'
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'
import TysiaIconPersonFilled from 'DesignSystem/Svgs/TysiaIconPersonFilled/index'
import TysiaOverlay from 'DesignSystem/TysiaOverlay/index'
import TysiaOverlayContent from 'DesignSystem/TysiaOverlay/TysiaOverlayContent/index'
import TysiaOverlayHeader from 'DesignSystem/TysiaOverlay/TysiaOverlayHeader/index'
import TysiaTag from 'DesignSystem/TysiaTag/index'
import TysiaTagText from 'DesignSystem/TysiaTag/TysiaTagText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Loading({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Loading"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaOverlay
  viewPath={`${viewPath}/TysiaOverlay`}
>
{childProps => (
<React.Fragment>
<TysiaOverlayHeader
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayHeader`}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Loading.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-2mx3jB': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaIconPersonFilled
  viewPath={`${viewPath}/TysiaIconPersonFilled`}
 width={dtSpaceS}
 height={dtSpaceS}
 fill={dtColorsNeutral600}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Patient profile"
/>
<div
  data-testid="Loading.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaTag
  viewPath={`${viewPath}/TysiaTag`}
 type="orange"
>
{childProps => (
<TysiaTagText
{...childProps}
  viewPath={`${viewPath}/TysiaTagText`}
 text="Beta"
/>
)}
</TysiaTag>
</div>
</div>
<CloseIconAction
{...childProps}
  viewPath={`${viewPath}/CloseIconAction`}
/>
</React.Fragment>
)}
</TysiaOverlayHeader>
<TysiaOverlayContent
{...childProps}
  viewPath={`${viewPath}/TysiaOverlayContent`}
>
{childProps => (
<div
  data-testid="Loading.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 delay={0}
/>
</div>
)}
</TysiaOverlayContent>
</React.Fragment>
)}
</TysiaOverlay>
{children}
</React.Fragment>)
}